import React, { useEffect } from "react";
import Layout from "../components/MenuBestof/Layout";
import listBestOf from "../requests/list";
import ModalOptions from "../components/OptionBestOf/ModalOptions";
import * as moment from 'moment'
import DatePicker from 'react-datepicker'
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';

// CSS
import "react-datepicker/dist/react-datepicker.css";
import { useMenuBestOf } from "../context/MenuBestOf";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gridTemplateColumns: 'repeat(8, 1fr)',
    gridGap: 10,
    gridAutoRows: 'minmax(10vh, auto)',
  },
  header: {
    gridColumn: "1 / 9",
    backgroundColor: theme.palette.background.paper,
    gridRow: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  yearPickerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  datePickerYear: {
    width: "50px",
    marginLeft: "5px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "12px",
    textAlign: "center",
    color: "inherit"
  },
  headerButtonGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: "30%"
  },
  layoutBestOf: {
    gridColumn: "1 / 9",
    gridRow: "2/10"
  }
}));

const MenuBestOf = () => {
  const { dispatch: dispatchMenu, state: stateMenu} = useMenuBestOf();
  const classes = useStyles();

  let sorteArrayByDate = (array: any[]) => {
    array.sort(function compare(a, b) {
      var dateA = moment.utc(a.created).toDate().valueOf();
      var dateB = moment.utc(b.created).toDate().valueOf();
      return dateA - dateB;
    });
    return (array.reverse());
  }

  const refreshBestOf = () => {
    dispatchMenu({type: "UPDATE_LOADING", payload: {isLoading: 1}})
    listBestOf(stateMenu.startDate.getFullYear(), stateMenu.typeBestOf)
      .then((data: any) => {
        if (data.Items) {
          dispatchMenu({type: "SET_ALL_BEST_OF", payload: {allBestOf: sorteArrayByDate(data.Items)}})
        }
        dispatchMenu({type: "UPDATE_LOADING", payload: {isLoading: 0}})
      })
      .catch(err => {
        console.log(err);
        dispatchMenu({type: "UPDATE_LOADING", payload: {isLoading: 0}})
      })
  }

  useEffect(() => {
    refreshBestOf();
    return () => {};
  }, [])

  useEffect(() => {
    refreshBestOf();
  }, [stateMenu.startDate, stateMenu.typeBestOf])

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <h1>Menu</h1>
        <div className={classes.yearPickerContainer}>
          <p>Choisir une année: </p>
          <DatePicker
            className={classes.datePickerYear}
            selected={stateMenu.startDate}
            onChange={date => dispatchMenu({type: "UPDATE_START_DATE", payload: {startDate: date}})}
            showYearPicker
            dateFormat="yyyy"
          />
          {/* <p style={{marginLeft: 20, marginRight: 5}}>Thèmes: </p>
          <select id="TypeBestOf" onChange={(e) => {dispatchMenu({type: "UPDATE_TYPE_BEST_OF", payload: {typeBestOf: parseInt(e.target.value)}})}} value={stateMenu.typeBestOf}>
            <option value={TypeBestOf.DAYS}>DAYS</option>
            <option value={TypeBestOf.THEME}>THEME</option>
          </select> */}
          <p style={{marginLeft: 20, marginRight: 5}}>Rafraichir: </p>
          <RefreshRoundedIcon onClick={() => refreshBestOf()} />
        </div>
      <div className={classes.headerButtonGroup}>
        <ModalOptions />
      </div>
      </div>
      <div className={classes.layoutBestOf}>
         <Layout />
      </div>
    </div>
  );
};

export default MenuBestOf;
